<div [formGroup]="investmentForm" class="investment-details" *ngIf="growAccount">
  <h3 class="ds-heading-1">{{ 'GROW.riskProfile.amount.title' | translate }}</h3>
  <p class="description">{{ 'GROW.riskProfile.amount.description' | translate }}</p>

  <!-- Initial investment -->
  <app-inyova-grow-investment-box
    formControlName="initial"
    [title]="'GROW.riskProfile.amount.initialInvestment.label' | translate: { currency: growAccount.currency }"
    [customAmount]="true"
    [chips]="initialInvestmentOptions"
    [hasError]="initial.invalid && (initial.dirty || riskFormSubmitted)"
  >
    <div *ngIf="initial.invalid && (initial.dirty || riskFormSubmitted)" class="ds-input-error">
      <ng-container *ngIf="initial.hasError('required')">
        {{ 'GROW.riskProfile.profile.errors.investRequired' | translate }}
      </ng-container>
      <ng-container *ngIf="initial.hasError('min')">
        {{
          'GROW.riskProfile.profile.errors.investMin'
            | translate: { investmentAmount: growAccount.minimum_investment | thousand: growAccount.currency }
        }}
      </ng-container>
    </div>
  </app-inyova-grow-investment-box>

  <!-- Savings plan -->
  <app-inyova-grow-investment-box
    formControlName="savings"
    [title]="'GROW.riskProfile.amount.savingsPlan.label' | translate: { currency: growAccount.currency }"
    [customAmount]="true"
    [savingsPlan]="true"
    [chips]="savingsPlanOptions"
  ></app-inyova-grow-investment-box>
</div>
